import { useEffect, useState } from "react"
import { Form } from "antd"
import { ButtonPrimary } from "components/ui/buttons/ButtonPrimary/ButtonPrimary"
import { ButtonSecondary } from "components/ui/buttons/ButtonSecondary/ButtonSecondary"
import { Input } from "components/ui/inputs/Input"
import { Modal } from "components/ui/modals/Modal/Modal"
import style from "./DefaultCompetitorModal.module.scss"

const { defaultCompetitorModal, inputWrapper, buttonsWrapper, input } = style

type Props = {
	isModalOpen: boolean
	setModalClose: () => void
	title: string
	inputLabel: string
	validationMessage: string
	cancelButtonText: string
	saveButtonText: string
	onSave: (value: string) => void
	initialValue?: string
}

export const DefaultCompetitorModal = ({
	isModalOpen,
	setModalClose,
	title,
	inputLabel,
	validationMessage,
	cancelButtonText,
	saveButtonText,
	onSave,
	initialValue,
}: Props) => {
	const [form] = Form.useForm()
	const values = Form.useWatch([], form)
	const [submittable, setSubmittable] = useState(false)

	// Set initial value when modal opens
	useEffect(() => {
		if (isModalOpen && initialValue !== undefined) {
			form.setFieldsValue({ name: initialValue })
		}
	}, [isModalOpen, initialValue, form])

	// Validate form fields to determine if the button should be submittable
	useEffect(() => {
		form.validateFields({ validateOnly: true }).then(
			() => {
				setSubmittable(true)
			},
			() => {
				setSubmittable(false)
			},
		)
	}, [values, form])

	const onSaveHandle = () => {
		onSave(values.name)
		form.resetFields()
	}

	return (
		<Modal isModalOpen={isModalOpen} setModalClose={setModalClose} title={title}>
			<Form form={form}>
				<div className={defaultCompetitorModal}>
					<div className={inputWrapper}>
						<span>{inputLabel}</span>
						<Form.Item name="name" rules={[{ required: true, message: validationMessage }]}>
							<Input className={input} />
						</Form.Item>
					</div>
					<div className={buttonsWrapper}>
						<ButtonSecondary onClick={setModalClose}>{cancelButtonText}</ButtonSecondary>
						<ButtonPrimary submittable={submittable} onClick={() => onSaveHandle()}>
							{saveButtonText}
						</ButtonPrimary>
					</div>
				</div>
			</Form>
		</Modal>
	)
}
